import React, { useEffect, useState, useRef } from 'react'
import { observer } from 'mobx-react'
import DatePicker from '../DatePicker/DatePicker'
import { Input as Picklist } from '../Picklist'
import {formatTimestampToInputValue} from '../DatePicker/dateUtility'
import moment from 'moment-timezone'
import { getSuggestions, isTodayCheck } from '../../../utility'
import Label from '../Input/Label'

const DATE_FORMAT = 'YYYY-MM-DDTh:mm a'

interface DateTimeRangeProps {
  label: string;
  value: any;
  config: any;
  dateFormat: string;
  type: string;
  onChange: (date: any) => void;
  defaultValue: any;
  timeOnly: boolean;
}

const DateTimeRange = (props: DateTimeRangeProps) => {
  const { timeOnly, value, onChange, type, defaultValue, config: { rangePosition, suggestionsInterval, dpStartTime } = {} } = props
  const isInStartPosition = rangePosition !== 'end'

  const [timeValue, setTimeValue] = useState('')

  useEffect(() => {
    if (value || defaultValue) {
      const formattedValue = formatTimestampToInputValue((value || defaultValue), false, DATE_FORMAT, type)
      const time = formattedValue.split('T')[1]
      setTimeValue(time?.toUpperCase())
    }
    if (!value && timeValue) {
      setTimeValue('')
    }
  }, [value])


  const onDPChange = (date) => {
    let _date = date
    if (dpStartTime) {
      const isToday = isTodayCheck(new Date(date))
      const dateWTime = new Date(new Date(date).setHours(isToday ? new Date().getHours() + 1 : dpStartTime))
      _date = dateWTime.toISOString()
    }
    onChange(_date)
  }

  const setTime = (value: any, a?: any) => {
    if (a && a.action === 'create-option') {
      const time = /(?:^|\s)((1[0-2]|0?[1-9])(:?[0-5][0-9])?\s?(AM|PM))\s*$/gi
      const v = time.test(value?.value) ? value?.value : '9AM'
      return onTimePropositionSelect(v)
    }
    setTimeValue(value)
    onTimePropositionSelect(value)
  }

  const onTimePropositionSelect = (timeString) => {
    const dateValue = value || new Date().toISOString()
    const dateOnly = new Date(dateValue).toISOString().split('T')[0]
    const momentValue = moment(`${dateOnly} ${timeString}`, DATE_FORMAT)
    onChange(momentValue)
  }

  const datePicker = () => {
    return (
      <div
        style={{
          order: isInStartPosition ? 1 : 2,
          ...!isInStartPosition && { alignSelf: 'end' },
          width: '100%'
        }}
      >
        <DatePicker
          {...props}
          closeOnBlur
          type={'DATE'}
          label={null}
          value={value || defaultValue}
          onChange={onDPChange}
        />
      </div>
    )
  }

  const timePicker = () => {
    let options = getSuggestions(suggestionsInterval)
    if (!options.includes(timeValue)) {
      options = [timeValue, ...options]
    }
    return (
      <div
        className={isInStartPosition ? 'ml-1' : 'mr-1'}
        style={{
          order: isInStartPosition ? 2 : 1,
          ...isInStartPosition && { alignSelf: 'end' },
          width: timeOnly ? '100%' : '120px',
          overflow: 'hidden'
        }}
      >
        <Picklist
          openMenuOnFocus
          disableClear
          isCreatable
          value={timeValue}
          picklist={[...options, timeValue]}
          onValueChange={(v, a) => setTime(v, a)}
          onCreate={(v, a) => setTime(v, a)}
        />
      </div>
    )
  }

  return (
      <>
        <Label {...props} />
        <div className={`d-flex align-items-start w-100`}>
          {
            isInStartPosition
              ? <>
                <>
                  {!timeOnly && datePicker()}
                </>
                <>
                  {timePicker()}
                </>
              </>
              : <>
                <>
                  {timePicker()}
                </>
                <>
                  {!timeOnly && datePicker()}
                </>
              </>
          }
        </div>
      </>
    )

}

export default observer(DateTimeRange)
